import { clivApiRequest } from '@/utils/apiClient';
import { ApiRequestOptions } from '@/types/ApiRequestOptions';
import { Division } from '@/types/Division';
import { API_ENDPOINTS } from './endpoints.constant';
import { systemConfig } from '@/config/systemConfig';

export type FetchDivisionsResult = {
  divisions: Division[] | null;
  status: number;
  ok: boolean;
};

export const divisionsApi = {
  /**
   * Fetch all divisions from the API
   */
  async fetchDivisions(): Promise<FetchDivisionsResult> {
    try {
      const apiRequest: ApiRequestOptions = {
        url: `${systemConfig.apiUrl}/${API_ENDPOINTS.META.DIVISIONS}`,
      };

      const response = await clivApiRequest<Array<Division>>(apiRequest);

      if (response.ok) {
        return {
          divisions: response.data,
          status: response.status,
          ok: true,
        };
      }
      console.error('Error fetching divisions:', response.error);
      return {
        divisions: null,
        status: response.status,
        ok: false,
      };
    } catch (error) {
      console.error('Error fetching divisions:', error);
      return {
        divisions: null,
        status: 0,
        ok: false,
      };
    }
  },
};
